export const comments = [
  {
    id: 1,
    name: "樱花落满地",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20girl%20portrait%20avatar%20with%20pink%20hair%20and%20big%20eyes%20cute%20expression%20simple%20clean%20background%20soft%20lighting%20illustration&width=80&height=80&seq=avatar-01&orientation=squarish",
    time: "2小时前",
    content: "最近在皮皮喵追《她的伪装》真的太上头了！画风绝美剧情也在线，每天等更新就像等饭吃一样，推荐给所有喜欢韩漫的姐妹们！",
    likes: 128,
  },
  {
    id: 2,
    name: "二次元老司机",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20boy%20portrait%20avatar%20with%20blue%20hair%20cool%20expression%20simple%20clean%20background%20illustration&width=80&height=80&seq=avatar-02&orientation=squarish",
    time: "5小时前",
    content: "看了十年漫画，皮皮喵是体验最好的中文平台之一了。资源全、加载快，关键是分类做得好，想找什么类型直接点标签就完事了。",
    likes: 96,
  },
  {
    id: 3,
    name: "小猫咪追漫中",
    avatar: "https://readdy.ai/api/search-image?query=Cute%20anime%20style%20cat%20girl%20avatar%20with%20orange%20hair%20and%20cat%20ears%20smiling%20simple%20clean%20background%20illustration&width=80&height=80&seq=avatar-03&orientation=squarish",
    time: "1天前",
    content: "从贴吧追过来的老用户了，皮皮喵页面干净没有乱七八糟的广告，而且更新速度真的快！国漫栏目也越来越丰富了，加油！",
    likes: 203,
  },
  {
    id: 4,
    name: "夜雨声烦",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20boy%20portrait%20avatar%20with%20dark%20hair%20and%20glasses%20serious%20expression%20simple%20clean%20background%20illustration&width=80&height=80&seq=avatar-04&orientation=squarish",
    time: "1天前",
    content: "说真的，现在能静下心来看漫画的地方越来越少了。皮皮喵是个好去处，界面清爽、资源也全，希望越做越好。",
    likes: 67,
  },
  {
    id: 5,
    name: "星月夜未眠",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20girl%20portrait%20avatar%20with%20purple%20hair%20dreamy%20expression%20star%20background%20simple%20clean%20illustration&width=80&height=80&seq=avatar-05&orientation=squarish",
    time: "2天前",
    content: "新入坑用户！朋友推荐来的，一口气刷了好几部韩漫，简直停不下来。最喜欢首页的推荐榜单，每次都能发现宝藏漫画！",
    likes: 156,
  },
];

export const topics = [
  { id: 1, name: "#韩漫推荐", count: "2.3w+ 讨论", hot: true },
  { id: 2, name: "#日漫经典", count: "1.8w+ 讨论", hot: true },
  { id: 3, name: "#国漫崛起", count: "1.5w+ 讨论", hot: true },
  { id: 4, name: "#恋爱甜漫", count: "9.8k+ 讨论", hot: false },
  { id: 5, name: "#悬疑烧脑", count: "7.2k+ 讨论", hot: false },
  { id: 6, name: "#热血少年", count: "6.5k+ 讨论", hot: false },
  { id: 7, name: "#奇幻冒险", count: "5.9k+ 讨论", hot: false },
  { id: 8, name: "#校园青春", count: "5.1k+ 讨论", hot: false },
  { id: 9, name: "#耽美专区", count: "4.8k+ 讨论", hot: false },
  { id: 10, name: "#新番速递", count: "4.2k+ 讨论", hot: true },
];

export const carousel = [
  {
    id: 1,
    title: "2024年度韩漫TOP10盘点",
    subtitle: "从恋爱到悬疑，这一年你不能错过的韩漫都在这里",
    tag: "年度企划",
    image: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20drama%20illustration%20style%20beautiful%20couple%20under%20cherry%20blossoms%20warm%20lighting%20soft%20colors%20anime%20art%20style%20emotional%20scene%20clean%20composition&width=600&height=360&seq=carousel-01&orientation=landscape",
  },
  {
    id: 2,
    title: "日漫经典永不过时——那些年我们追过的神作",
    subtitle: "从《海贼王》到《咒术回战》，日漫的永恒魅力解析",
    tag: "经典回顾",
    image: "https://readdy.ai/api/search-image?query=Japanese%20manga%20shonen%20action%20illustration%20style%20dynamic%20battle%20scene%20with%20warrior%20character%20epic%20composition%20vibrant%20colors%20anime%20art%20style%20dramatic%20lighting&width=600&height=360&seq=carousel-02&orientation=landscape",
  },
  {
    id: 3,
    title: "国漫崛起之路：从追赶到并跑的十年",
    subtitle: "盘点近年来口碑与人气双丰收的国产漫画精品",
    tag: "深度专题",
    image: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20martial%20arts%20cultivation%20illustration%20style%20ancient%20Chinese%20warrior%20with%20flowing%20robes%20in%20mountain%20landscape%20ink%20wash%20style%20elegant%20composition%20warm%20tones&width=600&height=360&seq=carousel-03&orientation=landscape",
  },
  {
    id: 4,
    title: "恋爱漫画入门指南：从零开始找到你的本命",
    subtitle: "不管你喜欢甜宠、虐心还是搞笑，这里都有你的菜",
    tag: "新手必看",
    image: "https://readdy.ai/api/search-image?query=Romance%20manga%20illustration%20style%20two%20high%20school%20students%20blushing%20under%20cherry%20blossom%20tree%20soft%20pink%20and%20warm%20colors%20dreamy%20atmosphere%20anime%20art%20style%20clean%20composition&width=600&height=360&seq=carousel-04&orientation=landscape",
  },
  {
    id: 5,
    title: "悬疑漫画大赏：那些让你彻夜难眠的神作",
    subtitle: "反转再反转！精选烧脑悬疑漫画，挑战你的推理能力",
    tag: "编辑精选",
    image: "https://readdy.ai/api/search-image?query=Mystery%20thriller%20manga%20illustration%20style%20dark%20atmosphere%20detective%20character%20in%20rainy%20city%20street%20neo%20noir%20lighting%20dramatic%20shadows%20anime%20art%20style%20cinematic%20composition&width=600&height=360&seq=carousel-05&orientation=landscape",
  },
];

export const ranking = [
  { id: 1, rank: 1, title: "她的伪装", type: "韩漫", tags: ["恋爱", "都市", "剧情"], hot: "9.8分", update: "每周三更新" },
  { id: 2, rank: 2, title: "咒术回战", type: "日漫", tags: ["热血", "奇幻", "战斗"], hot: "9.7分", update: "每周一更新" },
  { id: 3, rank: 3, title: "一人之下", type: "国漫", tags: ["玄幻", "冒险", "搞笑"], hot: "9.6分", update: "每周五更新" },
  { id: 4, rank: 4, title: "狂王", type: "国漫", tags: ["热血", "武侠", "剧情"], hot: "9.5分", update: "每周四更新" },
  { id: 5, rank: 5, title: "A Man's Man", type: "韩漫", tags: ["商战", "剧情", "逆袭"], hot: "9.4分", update: "每周六更新" },
];

export const features = [
  {
    id: 1,
    icon: "ri-book-open-line",
    title: "海量漫画资源",
    description: "收录韩漫、日漫、国漫等数万部热门漫画，涵盖恋爱、热血、悬疑、奇幻等全品类内容，每日更新不断档。",
  },
  {
    id: 2,
    icon: "ri-smartphone-line",
    title: "高清流畅阅读",
    description: "自适应屏幕尺寸的高清漫画阅读体验，加载速度快，翻页流畅，支持横屏竖屏自由切换。",
  },
  {
    id: 3,
    icon: "ri-thumb-up-line",
    title: "智能推荐引擎",
    description: "基于你的阅读偏好智能推荐同类型优质漫画，发现更多符合口味的好作品，告别漫荒。",
  },
  {
    id: 4,
    icon: "ri-shield-check-line",
    title: "纯净无广告体验",
    description: "专注内容本身，页面清爽整洁无扰人广告，为你提供最纯粹舒适的漫画阅读环境。",
  },
];

export const faq = [
  {
    id: 1,
    question: "皮皮喵漫画是免费阅读的吗？",
    answer: "是的，皮皮喵漫画所有内容均为免费在线阅览。我们致力于为广大漫画爱好者提供零门槛的阅读体验，无需注册即可畅读海量热门漫画资源，真正实现随时随地想看就看。",
  },
  {
    id: 2,
    question: "漫画更新频率是怎样的？",
    answer: "不同作品的更新频率因版权方和翻译进度而异，热门连载漫画通常保持周更或双周更节奏。我们会在漫画有更新时第一时间同步，确保你能追到最新剧情。",
  },
  {
    id: 3,
    question: "如何在手机上获得更好的阅读体验？",
    answer: "皮皮喵漫画网页版已针对移动端进行了全面适配，直接用手机浏览器访问即可获得流畅的竖屏阅读体验。我们也提供了APP下载入口，APP端支持离线下载和夜间模式等更多功能。",
  },
  {
    id: 4,
    question: "支持哪些类型的漫画内容？",
    answer: "目前我们覆盖韩漫、日漫、国漫三大品类，具体包括恋爱、热血、悬疑、奇幻、校园、搞笑、武侠、都市、耽美等十余个细分类型，几乎囊括了当下所有热门漫画种类。",
  },
];

export const media = [
  {
    id: 1,
    title: "《她的伪装》角色深度解析",
    thumbnail: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20character%20analysis%20video%20thumbnail%20style%20elegant%20female%20character%20with%20mysterious%20expression%20soft%20dramatic%20lighting%20warm%20tones%20anime%20art%20style%20cinematic%20look&width=400&height=240&seq=media-01&orientation=landscape",
    duration: "12:30",
    category: "角色解读",
  },
  {
    id: 2,
    title: "十大必看国漫神作推荐合集",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20collection%20thumbnail%20style%20epic%20martial%20arts%20scene%20with%20multiple%20characters%20dramatic%20composition%20vibrant%20warm%20colors%20anime%20art%20style%20cinematic%20look&width=400&height=240&seq=media-02&orientation=landscape",
    duration: "08:45",
    category: "盘点推荐",
  },
  {
    id: 3,
    title: "韩漫vs日漫作画风格对比",
    thumbnail: "https://readdy.ai/api/search-image?query=Manga%20art%20style%20comparison%20thumbnail%20split%20screen%20Korean%20and%20Japanese%20manga%20illustration%20styles%20side%20by%20side%20clean%20composition%20warm%20colors%20anime%20art%20style&width=400&height=240&seq=media-03&orientation=landscape",
    duration: "15:20",
    category: "科普解读",
  },
  {
    id: 4,
    title: "漫画新手必知：从选漫到追更全攻略",
    thumbnail: "https://readdy.ai/api/search-image?query=Manga%20reading%20guide%20thumbnail%20style%20cozy%20reading%20scene%20with%20tablet%20and%20manga%20books%20warm%20lighting%20inviting%20atmosphere%20clean%20composition%20soft%20colors&width=400&height=240&seq=media-04&orientation=landscape",
    duration: "06:10",
    category: "新手教程",
  },
];

export const updates = [
  { id: 1, date: "07-28", tag: "新番上线", title: "韩漫《恶女的审判》第1话正式上线", time: "今日 14:30" },
  { id: 2, date: "07-28", tag: "更新通知", title: "《一人之下》第586话已更新，速来围观", time: "今日 12:00" },
  { id: 3, date: "07-28", tag: "活动公告", title: "「暑期追漫季」阅读打卡活动火热进行中", time: "今日 09:00" },
  { id: 4, date: "07-27", tag: "新番上线", title: "日漫《葬送的芙莉莲》官方中文版入驻", time: "昨日 18:20" },
  { id: 5, date: "07-27", tag: "更新通知", title: "《她的伪装》第94话热更，剧情迎来大反转", time: "昨日 15:00" },
  { id: 6, date: "07-26", tag: "功能上线", title: "评论区点赞功能开放，为你喜欢的评论打call", time: "2天前" },
  { id: 7, date: "07-25", tag: "更新通知", title: "《狂王》第203话更新，终章决战即将开启", time: "3天前" },
  { id: 8, date: "07-24", tag: "专题上线", title: "「国漫精品」专题页面正式发布，精选50+佳作", time: "4天前" },
];

export const cards = [
  {
    id: 1,
    title: "恋爱甜漫合集",
    subtitle: "甜到牙疼！25部高甜恋爱漫画推荐",
    image: "https://readdy.ai/api/search-image?query=Romance%20manga%20cover%20art%20style%20cute%20couple%20hugging%20under%20cherry%20blossoms%20soft%20pink%20and%20warm%20colors%20dreamy%20atmosphere%20anime%20art%20style%20clean%20composition%20simple%20background&width=400&height=280&seq=cards-01&orientation=landscape",
    tag: "恋爱",
    count: "25部精选",
  },
  {
    id: 2,
    title: "热血战斗精选",
    subtitle: "燃到爆！30部高分热血漫画推荐",
    image: "https://readdy.ai/api/search-image?query=Action%20manga%20cover%20art%20style%20epic%20battle%20scene%20with%20two%20warriors%20clashing%20dynamic%20composition%20vibrant%20warm%20colors%20anime%20art%20style%20dramatic%20lighting%20simple%20background&width=400&height=280&seq=cards-02&orientation=landscape",
    tag: "热血",
    count: "30部精选",
  },
  {
    id: 3,
    title: "悬疑烧脑剧场",
    subtitle: "反转不断！20部高智商漫画推荐",
    image: "https://readdy.ai/api/search-image?query=Mystery%20manga%20cover%20art%20style%20dark%20moody%20atmosphere%20with%20detective%20silhouette%20and%20clues%20dramatic%20lighting%20warm%20dark%20tones%20anime%20art%20style%20simple%20background&width=400&height=280&seq=cards-03&orientation=landscape",
    tag: "悬疑",
    count: "20部精选",
  },
  {
    id: 4,
    title: "奇幻冒险之旅",
    subtitle: "打开新世界！18部奇幻异世界漫画",
    image: "https://readdy.ai/api/search-image?query=Fantasy%20manga%20cover%20art%20style%20magical%20world%20with%20floating%20islands%20and%20adventurer%20character%20vibrant%20warm%20colors%20dreamy%20atmosphere%20anime%20art%20style%20simple%20background&width=400&height=280&seq=cards-04&orientation=landscape",
    tag: "奇幻",
    count: "18部精选",
  },
  {
    id: 5,
    title: "校园青春物语",
    subtitle: "回忆杀！22部经典校园漫画推荐",
    image: "https://readdy.ai/api/search-image?query=School%20life%20manga%20cover%20art%20style%20students%20in%20classroom%20with%20warm%20afternoon%20sunlight%20nostalgic%20atmosphere%20soft%20warm%20colors%20anime%20art%20style%20simple%20background&width=400&height=280&seq=cards-05&orientation=landscape",
    tag: "校园",
    count: "22部精选",
  },
  {
    id: 6,
    title: "耽美佳作推荐",
    subtitle: "口碑炸裂！15部高分BL漫画盘点",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20boys%20love%20manga%20cover%20art%20style%20two%20handsome%20male%20characters%20close%20together%20elegant%20composition%20soft%20warm%20lighting%20anime%20art%20style%20simple%20background&width=400&height=280&seq=cards-06&orientation=landscape",
    tag: "耽美",
    count: "15部精选",
  },
  {
    id: 7,
    title: "武侠国漫精品",
    subtitle: "国风之美！20部优质武侠国漫合集",
    image: "https://readdy.ai/api/search-image?query=Chinese%20wuxia%20manhua%20cover%20art%20style%20martial%20artist%20with%20sword%20in%20ancient%20Chinese%20landscape%20ink%20wash%20aesthetic%20elegant%20warm%20tones%20anime%20art%20style%20simple%20background&width=400&height=280&seq=cards-07&orientation=landscape",
    tag: "武侠",
    count: "20部精选",
  },
];

export const indexTopics = [
  { id: 1, name: "韩漫", icon: "ri-global-line", count: "800+ 部", description: "恋爱、都市、悬疑、耽美等热门韩漫" },
  { id: 2, name: "日漫", icon: "ri-earth-line", count: "1200+ 部", description: "热血、奇幻、校园、经典日漫原作" },
  { id: 3, name: "国漫", icon: "ri-map-pin-line", count: "600+ 部", description: "武侠、玄幻、搞笑等国风漫画" },
  { id: 4, name: "恋爱专区", icon: "ri-heart-line", count: "350+ 部", description: "甜宠、虐恋、青梅竹马恋爱漫画" },
  { id: 5, name: "热血动作", icon: "ri-fire-line", count: "280+ 部", description: "战斗、竞技、冒险热血漫画" },
  { id: 6, name: "悬疑推理", icon: "ri-search-eye-line", count: "150+ 部", description: "烧脑、反转、惊悚推理漫画" },
  { id: 7, name: "新番速递", icon: "ri-rocket-line", count: "本周更新", description: "最新上架和本周更新漫画汇总" },
  { id: 8, name: "编辑精选", icon: "ri-star-line", count: "精品推荐", description: "编辑团队精选高分优质漫画" },
];

export const contactInfo = {
  email: "contact@pipimiao.com",
  wechat: "皮皮喵漫画",
  description: "商务合作、版权咨询、内容投稿，欢迎通过以下方式联系我们。我们珍惜每一位读者的反馈和建议！",
};

export const aboutInfo = {
  title: "关于皮皮喵漫画",
  description: "皮皮喵漫画是一个专注韩漫、日漫、国漫的免费在线阅读平台。我们致力于为中文读者提供海量高清漫画资源，覆盖恋爱、热血、悬疑、奇幻、校园、武侠等全品类热门漫画。每日同步更新，让追更不再等待。从经典日漫神作到最新韩漫连载，从口碑国漫到小众精品，皮皮喵漫画用心打造属于漫画爱好者的精神家园。",
};